mutation UpdateLanguage($id: ID!, $input: UpdateLanguageInput!) {
  updateLanguage(id: $id, input: $input) {
    id
  }
}
